// eslint-disable-next-line no-unused-vars
var movesEs = {
    "1": "Destructor",
    "2": "Golpe Karate",
    "3": "Doble Bofetón",
    "4": "Puño Cometa",
    "5": "Megapuño",
    "6": "Día de Pago",
    "7": "Puño Fuego",
    "8": "Puño Hielo",
    "9": "Puño Trueno",
    "10": "Arañazo",
    "11": "Fuerza de Garra",
    "12": "Guillotina",
    "13": "Viento Cortante",
    "14": "Danza de Espadas",
    "15": "Corte",
    "16": "Ráfaga de Aire",
    "17": "Ataque de Ala",
    "18": "Torbellino",
    "19": "Vuelo",
    "20": "Atadura",
    "21": "Golpazo",
    "22": "Látigo Cepa",
    "23": "Pisotón",
    "24": "Doble Patada",
    "25": "Megapatada",
    "26": "Patada Salto",
    "27": "Patada Giro",
    "28": "Ataque Arena",
    "29": "Golpe Cabeza",
    "30": "Ataque Cuerno",
    "31": "Ataque Furia",
    "32": "Cuerno Taladro",
    "33": "Tacleada",
    "34": "Golpe de Cuerpo",
    "35": "Constricción",
    "36": "Derribo",
    "37": "Golpiza",
    "38": "Doble Filo",
    "39": "Látigo de Cola",
    "40": "Piquete Venenoso",
    "41": "Doble Aguijón",
    "42": "Misil Aguja",
    "43": "Malicioso",
    "44": "Mordida",
    "45": "Gruñido",
    "46": "Rugido",
    "47": "Canto",
    "48": "Supersónico",
    "49": "Explosión Sónica",
    "50": "Anulación",
    "51": "Ácido",
    "52": "Brasas",
    "53": "Lanzallamas",
    "54": "Neblina",
    "55": "Chorro de Agua",
    "56": "Hidrobomba",
    "57": "Surf",
    "58": "Rayo de Hielo",
    "59": "Ventisca",
    "60": "Psicorrayo",
    "61": "Rayo Burbuja",
    "62": "Rayo Aurora",
    "63": "Hiperrayo",
    "64": "Picotazo",
    "65": "Pico Taladro",
    "66": "Sumisión",
    "67": "Patada Baja",
    "68": "Contraataque",
    "69": "Sísmico",
    "70": "Fuerza",
    "71": "Absorción",
    "72": "Megadrenado",
    "73": "Drenadoras",
    "74": "Crecimiento",
    "75": "Hojas Navaja",
    "76": "Rayo Solar",
    "77": "Polvo Venenoso",
    "78": "Paralizador",
    "79": "Somnífero",
    "80": "Danza de Pétalos",
    "81": "Disparo de Seda",
    "82": "Furia Dragón",
    "83": "Giro Fuego",
    "84": "Impactrueno",
    "85": "Atactrueno",
    "86": "Onda Trueno",
    "87": "Trueno",
    "88": "Lanzarrocas",
    "89": "Terremoto",
    "90": "Fisura",
    "91": "Excavar",
    "92": "Tóxico",
    "93": "Confusión",
    "94": "Fuerza Psíquica",
    "95": "Hipnosis",
    "96": "Meditación",
    "97": "Agilidad",
    "98": "Ataque Rápido",
    "99": "Furia",
    "100": "Teletransporte",
    "101": "Tinieblas",
    "102": "Mímica",
    "103": "Chillido",
    "104": "Doble Equipo",
    "105": "Recuperación",
    "106": "Fortaleza",
    "107": "Reducción",
    "108": "Pantalla de Humo",
    "109": "Rayo de Confusión",
    "110": "Refugio",
    "111": "Hacerse Bolita",
    "112": "Barrera",
    "113": "Pantalla de Luz",
    "114": "Niebla",
    "115": "Reflejo",
    "116": "Centrar Energía",
    "117": "Venganza",
    "118": "Metrónomo",
    "119": "Espejo",
    "120": "Autodestrucción",
    "121": "Bomba Huevo",
    "122": "Leng\u00fcetazo",
    "123": "Humo",
    "124": "Residuos",
    "125": "Maza de Hueso",
    "126": "Llamarada",
    "127": "Cascada",
    "128": "Tenaza",
    "129": "Meteoros",
    "130": "Cabezazo",
    "131": "Cañón de Púas",
    "132": "Restricción",
    "133": "Amnesia",
    "134": "Kinético",
    "135": "Ovocuración",
    "136": "Pat. Salto Alto",
    "137": "Fulmirada",
    "138": "Comesueños",
    "139": "Gas Venenoso",
    "140": "Bombardeo",
    "141": "Chupavidas",
    "142": "Beso Amoroso",
    "143": "Ataque Celestial",
    "144": "Transformación",
    "145": "Burbuja",
    "146": "Puño Mareador",
    "147": "Esporas",
    "148": "Destello",
    "149": "Psicoonda",
    "150": "Salpicadura",
    "151": "Armadura Ácida",
    "152": "Martillazo",
    "153": "Explosión",
    "154": "Garras Furiosas",
    "155": "Huesomerang",
    "156": "Descanso",
    "157": "Avalancha",
    "158": "Hipercolmillo",
    "159": "Afilar",
    "160": "Conversión",
    "161": "Triataque",
    "162": "Supercolmillo",
    "163": "Cuchillada",
    "164": "Sustituto",
    "165": "Forcejeo",
    "166": "Boceto",
    "167": "Triple Patada",
    "168": "Ladrón",
    "169": "Telaraña",
    "170": "Telépata",
    "171": "Pesadilla",
    "172": "Rueda Ígnea",
    "173": "Ronquido",
    "174": "Maldición",
    "175": "Azote",
    "176": "Conversión 2",
    "177": "Aerochorro",
    "178": "Esporagodón",
    "179": "Inversión",
    "180": "Rencor",
    "181": "Polvo de Nieve",
    "182": "Protección",
    "183": "Superpuño",
    "184": "Cara Aterradora",
    "185": "Ataque Finta",
    "186": "Beso Dulce",
    "187": "Tambor",
    "188": "Bomba Lodo",
    "189": "Bofetón Lodo",
    "190": "Octazuca",
    "191": "Púas",
    "192": "Electrocañón",
    "193": "Visión",
    "194": "Lazo del Destino",
    "195": "Canto Mortal",
    "196": "Viento Helado",
    "197": "Detección",
    "198": "Hueso Veloz",
    "199": "Fijar Blanco",
    "200": "Enfado",
    "201": "Tormenta Arena",
    "202": "Gigadrenado",
    "203": "Aguante",
    "204": "Encanto",
    "205": "Rodada",
    "206": "Falsa Bofetada",
    "207": "Fanfarronear",
    "208": "Licuado",
    "209": "Chispa",
    "210": "Corte Furia",
    "211": "Ala de Acero",
    "212": "Mal de Ojo",
    "213": "Atracción",
    "214": "Sonámbulo",
    "215": "Cascabel Sanador",
    "216": "Retribución",
    "217": "Obsequio",
    "218": "Frustración",
    "219": "Velo Sagrado",
    "220": "Dividedolor",
    "221": "Fuego Sagrado",
    "222": "Magnitud",
    "223": "Puño Dinámico",
    "224": "Megacuerno",
    "225": "Aliento Dragón",
    "226": "Relevo",
    "227": "Otra Vez",
    "228": "Persecución",
    "229": "Giro Rápido",
    "230": "Dulce Aroma",
    "231": "Cola de Hierro",
    "232": "Garra de Metal",
    "233": "Llave Vital",
    "234": "Sol Matutino",
    "235": "Síntesis",
    "236": "Luz Lunar",
    "237": "Poder Oculto",
    "238": "Golpe Cruzado",
    "239": "Tornado",
    "240": "Danza de Lluvia",
    "241": "Día Soleado",
    "242": "Triturar",
    "243": "Escudo Espejo",
    "244": "Autosugestión",
    "245": "Veloc. Extrema",
    "246": "Poder Antiguo",
    "247": "Bola Sombra",
    "248": "Premonición",
    "249": "Golpe Roca",
    "250": "Remolino",
    "251": "Paliza",
    "252": "Sorpresa",
    "253": "Alboroto",
    "254": "Reserva",
    "255": "Escupida",
    "256": "Tragar",
    "257": "Onda Ígnea",
    "258": "Granizo",
    "259": "Tormento",
    "260": "Halago",
    "261": "Fuego Fatuo",
    "262": "Recuerdo",
    "263": "Fachada",
    "264": "Puño Centrado",
    "265": "Estímulo",
    "266": "Señuelo",
    "267": "Adaptación",
    "268": "Carga",
    "269": "Provocación",
    "270": "Refuerzos",
    "271": "Truco",
    "272": "Imitación",
    "273": "Deseo",
    "274": "Ayuda",
    "275": "Arraigo",
    "276": "Fuerza Bruta",
    "277": "Capa Mágica",
    "278": "Reciclaje",
    "279": "Desquite",
    "280": "Karatazo",
    "281": "Bostezo",
    "282": "Desarme",
    "283": "Esfuerzo",
    "284": "Estallido",
    "285": "Intercambio",
    "286": "Sellar",
    "287": "Alivio",
    "288": "Rabia",
    "289": "Robo",
    "290": "Poder Secreto",
    "291": "Buceo",
    "292": "Empujón",
    "293": "Camuflaje",
    "294": "Luminicola",
    "295": "Resplandor",
    "296": "Bola Neblina",
    "297": "Danza de Plumas",
    "298": "Danza del Caos",
    "299": "Patada Ígnea",
    "300": "Chapoteo de Lodo",
    "301": "Bola Hielo",
    "302": "Brazo Aguja",
    "303": "Relajar",
    "304": "Hipervoz",
    "305": "Colmillo Veneno",
    "306": "Garra Brutal",
    "307": "Anillo de Fuego",
    "308": "Hidrocañón",
    "309": "Puño Meteoro",
    "310": "Impresión",
    "311": "Meteorobola",
    "312": "Aromaterapia",
    "313": "Llanto Falso",
    "314": "Aire Cortante",
    "315": "Supercalor",
    "316": "Rastreo",
    "317": "Tumba de Rocas",
    "318": "Viento Plateado",
    "319": "Sonido Metálico",
    "320": "Silbato de Hoja",
    "321": "Cosquillas",
    "322": "Masa Cósmica",
    "323": "Columna de Agua",
    "324": "Rayo Señal",
    "325": "Puño Sombra",
    "326": "Extrasensorial",
    "327": "Corte Elevado",
    "328": "Tumba de Arena",
    "329": "Frío Extremo",
    "330": "Agua Lodosa",
    "331": "Bala Semilla",
    "332": "As Aéreo",
    "333": "Lanza de Hielo",
    "334": "Defensa Hierro",
    "335": "Bloqueo",
    "336": "Aullido",
    "337": "Garra Dragón",
    "338": "Planta Feroz",
    "339": "Corpulencia",
    "340": "Rebote",
    "341": "Disparo de Lodo",
    "342": "Cola Venenosa",
    "343": "Antojo",
    "344": "Tacleada de Voltios",
    "345": "Hojas Mágicas",
    "346": "Chapoteo de Agua",
    "347": "Paz Mental",
    "348": "Hoja Aguda",
    "349": "Danza de Dragón",
    "350": "Pedrada",
    "351": "Onda de Choque",
    "352": "Pulso de Agua",
    "353": "Deseo Final",
    "354": "Psicoimpulso",
    "355": "Respiro",
    "356": "Gravedad",
    "357": "Gran Ojo",
    "358": "Despabilador",
    "359": "Brazo Martillo",
    "360": "Giro Bola",
    "361": "Deseo Sanador",
    "362": "Agua Salada",
    "363": "Don Natural",
    "364": "Amago",
    "365": "Picoteo",
    "366": "Viento Afín",
    "367": "Acupresión",
    "368": "Expl. Metálica",
    "369": "Ida y Vuelta",
    "370": "Cuerpo a Cuerpo",
    "371": "Revancha",
    "372": "Garantía",
    "373": "Embargo",
    "374": "Lanzamiento",
    "375": "Psicocambio",
    "376": "As Oculto",
    "377": "Anticuración",
    "378": "Apretón",
    "379": "Truco Fuerza",
    "380": "Ácido Gástrico",
    "381": "Cántico Suerte",
    "382": "Yo Primero",
    "383": "Copión",
    "384": "Cambiafuerza",
    "385": "Cambiadefensa",
    "386": "Castigo",
    "387": "Último Recurso",
    "388": "Abatidoras",
    "389": "Golpe Bajo",
    "390": "Púas Tóxicas",
    "391": "Cambiaalmas",
    "392": "Acuaanillo",
    "393": "Superimán",
    "394": "Erupción",
    "395": "Fuerza de Palma",
    "396": "Aura Esfera",
    "397": "Pulimento",
    "398": "Golpe Venenoso",
    "399": "Pulso Oscuro",
    "400": "Corte Umbrío",
    "401": "Cola de Agua",
    "402": "Bomba Semilla",
    "403": "Corte Aéreo",
    "404": "Tijera X",
    "405": "Zumbido",
    "406": "Pulso Dragón",
    "407": "Carga Dragón",
    "408": "Joya de Luz",
    "409": "Puño Drenador",
    "410": "Onda de Vacío",
    "411": "Ataque Centrado",
    "412": "Bola de Energía",
    "413": "Ave Brava",
    "414": "Poder Terrestre",
    "415": "Trueque",
    "416": "Gigaimpacto",
    "417": "Maquinación",
    "418": "Puño Bala",
    "419": "Alud",
    "420": "Esquirla Helada",
    "421": "Garra de Sombra",
    "422": "Colmillo Trueno",
    "423": "Colmillo Hielo",
    "424": "Colmillo Fuego",
    "425": "Sombra Vil",
    "426": "Bomba Fango",
    "427": "Psicocorte",
    "428": "Cabezazo Zen",
    "429": "Disparo Espejo",
    "430": "Foco Resplandor",
    "431": "Treparrocas",
    "432": "Desempañar",
    "433": "Espacio Raro",
    "434": "Meteoro Dragón",
    "435": "Chispazo",
    "436": "Bomba de Lava",
    "437": "Tormenta Hojas",
    "438": "Latigazo",
    "439": "Romperrocas",
    "440": "Veneno X",
    "441": "Lanzamugre",
    "442": "Cabeza de Hierro",
    "443": "Magnetobomba",
    "444": "Roca Afilada",
    "445": "Seducción",
    "446": "Trampa de Rocas",
    "447": "Nudo de Pasto",
    "448": "Parloteo",
    "449": "Juicio Final",
    "450": "Picadura",
    "451": "Rayo Carga",
    "452": "Mazazo",
    "453": "Acuajet",
    "454": "Al Ataque",
    "455": "A Defender",
    "456": "Auxilio",
    "457": "Topetazo",
    "458": "Doble Golpe",
    "459": "Rugido Temporal",
    "460": "Corte Espacial",
    "461": "Danza de la Luna",
    "462": "Garra Aplastante",
    "463": "Lluvia Ígnea",
    "464": "Abismo Negro",
    "465": "Fulgor Semilla",
    "466": "Viento Ominoso",
    "467": "Golpe Umbrío",
    "468": "Afilagarras",
    "469": "Guardia Amplia",
    "470": "Guardia Dividida",
    "471": "Fuerza Dividida",
    "472": "Zona Extraña",
    "473": "Choque Psíquico",
    "474": "Carga Tóxica",
    "475": "Aligerar",
    "476": "Polvo Ira",
    "477": "Telequinesis",
    "478": "Zona Mágica",
    "479": "Antiaéreo",
    "480": "Llave Tempestad",
    "481": "Golpe de Fuego",
    "482": "Ola de Lodo",
    "483": "Danza del Aleteo",
    "484": "Golpe Pesado",
    "485": "Sincrorruido",
    "486": "Electrobola",
    "487": "Empapar",
    "488": "Carga de Fuego",
    "489": "Enrosque",
    "490": "Barredora",
    "491": "Bomba Ácida",
    "492": "Juego Sucio",
    "493": "Onda Simple",
    "494": "Danza Amiga",
    "495": "Ceda el Paso",
    "496": "Canon",
    "497": "Eco Voz",
    "498": "Guardia Baja",
    "499": "Humo Claro",
    "500": "Poder Acumulado",
    "501": "Defensa Rápida",
    "502": "Cambio de Lado",
    "503": "Escaldar",
    "504": "Rompecoraza",
    "505": "Pulso Sanador",
    "506": "Infortunio",
    "507": "Caída Libre",
    "508": "Cambio de Marcha",
    "509": "Llave Giro",
    "510": "Incinerar",
    "511": "Último Lugar",
    "512": "Acrobacia",
    "513": "Clonatipo",
    "514": "Represalia",
    "515": "Sacrificio",
    "516": "Ofrenda",
    "517": "Infierno",
    "518": "Voto Agua",
    "519": "Voto Fuego",
    "520": "Voto Planta",
    "521": "Cambiavoltaje",
    "522": "Lucha Insecto",
    "523": "Terratemblor",
    "524": "Vaho Helado",
    "525": "Cola de Dragón",
    "526": "Avivar",
    "527": "Electrotela",
    "528": "Carga Salvaje",
    "529": "Taladradora",
    "530": "Golpe Dual",
    "531": "Sello de Corazón",
    "532": "Drenacuerno",
    "533": "Espada Sagrada",
    "534": "Coraza Afilada",
    "535": "Golpe de Calor",
    "536": "Ciclón de Hojas",
    "537": "Aplanadora",
    "538": "Guardialgodón",
    "539": "Pulso Nocturno",
    "540": "Onda Mental",
    "541": "Golpe de Cola",
    "542": "Huracán",
    "543": "Carga de Cabeza",
    "544": "Rueda Doble",
    "545": "Bomba Ígnea",
    "546": "Tecno Shock",
    "547": "Canto Arcaico",
    "548": "Espada Secreta",
    "549": "Mundo Gélido",
    "550": "Ataque Fulgor",
    "551": "Llama Azul",
    "552": "Danza de Llamas",
    "553": "Rayo Gélido",
    "554": "Llama Gélida",
    "555": "Alarido",
    "556": "Carámbano",
    "557": "V de Fuego",
    "558": "Llama Fusión",
    "559": "Rayo Fusión",
    "560": "Plancha Voladora",
    "561": "Escudo Tatami",
    "562": "Eructo",
    "563": "Fertilizante",
    "564": "Red Pegajosa",
    "565": "Aguijón Letal",
    "566": "Golpe Fantasma",
    "567": "Halloween",
    "568": "Rugido de Guerra",
    "569": "Cortina Plasma",
    "570": "Carga Parabólica",
    "571": "Condena Silvana",
    "572": "Tormenta Pétalos",
    "573": "Liofilización",
    "574": "Voz Encantadora",
    "575": "Última Palabra",
    "576": "Reversión",
    "577": "Beso Drenador",
    "578": "Truco Defensa",
    "579": "Defensa Floral",
    "580": "Campo de Césped",
    "581": "Campo de Niebla",
    "582": "Electrificación",
    "583": "Juego Rudo",
    "584": "Viento Feérico",
    "585": "Fuerza Lunar",
    "586": "Estruendo",
    "587": "Cerrojo Feérico",
    "588": "Escudo Real",
    "589": "Camaradería",
    "590": "Confidencia",
    "591": "Torm. Diamantes",
    "592": "Chorro de Vapor",
    "593": "Paso Dimensional",
    "594": "Shuriken de Agua",
    "595": "Fuego Místico",
    "596": "Barrera Espinosa",
    "597": "Niebla Aromática",
    "598": "Onda Anómala",
    "599": "Trampa Venenosa",
    "600": "Pólvora",
    "601": "Geocontrol",
    "602": "Aura Magnética",
    "603": "Paga Extra",
    "604": "Campo Eléctrico",
    "605": "Brillo Mágico",
    "606": "Celebración",
    "607": "Manos Juntas",
    "608": "Ojitos Tiernos",
    "609": "Frote",
    "610": "Clemencia",
    "611": "Infestación",
    "612": "Puño Incremento",
    "613": "Ala del Olvido",
    "614": "Mil Flechas",
    "615": "Mil Temblores",
    "616": "Fuerza Telúrica",
    "617": "Luz Aniquiladora",
    "618": "Pulso Primigenio",
    "619": "Filo del Abismo",
    "620": "Ascen. Dracónico",
    "621": "Cerco Dimensión",
    "622": "Carrera Arrolladora",
    "623": "Carrera Arrolladora",
    "624": "Ráfaga Demoledora",
    "625": "Ráfaga Demoledora",
    "626": "Picada Supersónica",
    "627": "Picada Supersónica",
    "628": "Diluvio Corrosivo",
    "629": "Diluvio Corrosivo",
    "630": "Barrena Telúrica",
    "631": "Barrena Telúrica",
    "632": "Aplastamiento Gigalítico",
    "633": "Aplastamiento Gigalítico",
    "634": "Guadaña Sedosa",
    "635": "Guadaña Sedosa",
    "636": "Presa Espectral",
    "637": "Presa Espectral",
    "638": "Hélice Trepanadora",
    "639": "Hélice Trepanadora",
    "640": "Hecatombe Pírica",
    "641": "Hecatombe Pírica",
    "642": "Hidrovórtice Abisal",
    "643": "Hidrovórtice Abisal",
    "644": "Megatón Floral",
    "645": "Megatón Floral",
    "646": "Gigavoltio Destructor",
    "647": "Gigavoltio Destructor",
    "648": "Disruptor Psíquico",
    "649": "Disruptor Psíquico",
    "650": "Crioaliento Despiadado",
    "651": "Crioaliento Despiadado",
    "652": "Dracoaliento Devastador",
    "653": "Dracoaliento Devastador",
    "654": "Agujero Negro Aniquilador",
    "655": "Agujero Negro Aniquilador",
    "656": "Tacleada Sideral",
    "657": "Tacleada Sideral",
    "658": "Pikavoltio Letal",
    "659": "Recogearena",
    "660": "Escaramuza",
    "661": "Búnker",
    "662": "Puntada Sombría",
    "663": "Lariat Oscuro",
    "664": "Aria Burbuja",
    "665": "Martillo Hielo",
    "666": "Flores Sanadoras",
    "667": "Fuerza Equina",
    "668": "Absorbefuerza",
    "669": "Cuchillada Solar",
    "670": "Follaje",
    "671": "Foco",
    "672": "Hilo Venenoso",
    "673": "Agudizar",
    "674": "Engranajes",
    "675": "Golpe al Cuello",
    "676": "Bola de Polen",
    "677": "Anclaje",
    "678": "Campo Psíquico",
    "679": "Plancha",
    "680": "Látigo Ígneo",
    "681": "Arrogancia",
    "682": "Llama Final",
    "683": "Cambiavelocidad",
    "684": "Cuerno Certero",
    "685": "Purificación",
    "686": "Danza Revelación",
    "687": "Núcleo Castigo",
    "688": "Patada Tropical",
    "689": "Mandato",
    "690": "Pico Cañón",
    "691": "Fragor Escamas",
    "692": "Martillo Dragón",
    "693": "Giro Vil",
    "694": "Velo Aurora",
    "695": "Aluvión de Flechas Sombrías",
    "696": "Hiperplancha Oscura",
    "697": "Sinfonía de la Diva Marina",
    "698": "Cólera del Guardián",
    "699": "Constelación Robaalmas",
    "700": "Surfeo Galvánico",
    "701": "Arrojo Intempestivo",
    "702": "Novena Potencia",
    "703": "Supernova Original",
    "704": "Trampa Coraza",
    "705": "Cañón Floral",
    "706": "Psicocolmillo",
    "707": "Pataleta",
    "708": "Hueso Sombrío",
    "709": "Roca Veloz",
    "710": "Hidroariete",
    "711": "Láser Prisma",
    "712": "Robasombra",
    "713": "Meteoimpacto",
    "714": "Rayo Umbrío",
    "715": "Ojos Llorosos",
    "716": "Electropunzada",
    "717": "Ira Natural",
    "718": "Multiataque",
    "719": "Gigarrayo Fulminante",
    "720": "Cabeza Sorpresa",
    "721": "Puños Plasma",
    "722": "Géiser Fotónico",
    "723": "Fotodestrucción Apocalíptica",
    "724": "Embestida Solar",
    "725": "Deflagración Lunar",
    "726": "Paliza Amistosa",
    "727": "Tempestad Rocosa",
    "728": "Estruendo Implacable",
    "729": "Pikaturbo",
    "730": "Salpikasurf",
    "731": "Pikaída",
    "732": "Pikatormenta",
    "733": "Vapodrenaje",
    "734": "Joltioparálisis",
    "735": "Flarembestida",
    "736": "Espeaura",
    "737": "Umbreozona",
    "738": "Leafitobombas",
    "739": "Glaceoprisma",
    "740": "Sylveotornado",
    "741": "Eevimpacto",
    "742": "Ferropuño Doble",
    "743": "Maxibarrera",
    "744": "Cañón Dinamax",
    "745": "Disparo Certero",
    "746": "Presa Maxilar",
    "747": "Atiborramiento",
    "748": "Bastión Final",
    "749": "Alquitranazo",
    "750": "Polvo Magia",
    "751": "Dracoflechas",
    "752": "Hora del Té",
    "753": "Octopresa",
    "754": "Electropico",
    "755": "Branquibocado",
    "756": "Cambio de Cancha",
    "757": "Maxignición",
    "758": "Maxinsecto",
    "759": "Maxitormenta",
    "760": "Maxiataque",
    "761": "Maxipuño",
    "762": "Maxiespectro",
    "763": "Maxihelada",
    "764": "Maxiácido",
    "765": "Maxichorro",
    "766": "Maxiciclón",
    "767": "Maxiestela",
    "768": "Maxidraco",
    "769": "Maxionda",
    "770": "Maxirroca",
    "771": "Maxitemblor",
    "772": "Maxisombra",
    "773": "Maxiflora",
    "774": "Maximetal",
    "775": "Estruendo Escama",
    "776": "Plancha Corporal",
    "777": "Decoración",
    "778": "Batería Asalto",
    "779": "Trampa Presión",
    "780": "Balón Ígneo",
    "781": "Corte Supremo",
    "782": "Golpe Supremo",
    "783": "Rueda Aural",
    "784": "Vasto Impacto",
    "785": "Ramazo Punzante",
    "786": "Amplificador",
    "787": "Ácido Málico",
    "788": "Fuerza G",
    "789": "Choque Anímico",
    "790": "Cautivapor",
    "791": "Gota Vital",
    "792": "Obstrucción",
    "793": "Irreverencia",
    "794": "Asalto Estelar",
    "795": "Rayo Infinito",
    "796": "Metaláser",
    "797": "Vasta Fuerza",
    "798": "Ferroaplanadora",
    "799": "Disparo Escamas",
    "800": "Rayo Meteórico",
    "801": "Moluscañón",
    "802": "Bruma Explosiva",
    "803": "Fitoimpulso",
    "804": "Alto Voltaje",
    "805": "Pulso de Campo",
    "806": "Golpe Rastrero",
    "807": "Envidia Ardiente",
    "808": "Desahogo",
    "809": "Poltergeist",
    "810": "Gas Corrosivo",
    "811": "Motivación",
    "812": "Viraje",
    "813": "Triple Axel",
    "814": "Aletazo Doble",
    "815": "Arenas Ardientes",
    "816": "Selva Sanadora",
    "817": "Golpe Oscuro",
    "818": "Golpe Torrencial",
    "819": "Electrojaula",
    "820": "Dracoenergía",
    "821": "Mirada Glacial",
    "822": "Furia Candente",
    "823": "Patada Relámpago",
    "824": "Lanza Glacial",
    "825": "Orbes Espectro",
    "826": "Conjuro Funesto",
    "827": "Garra Nociva",
    "828": "Asalto Barrera",
    "829": "Cambiapoder",
    "830": "Hachazo Pétreo",
    "831": "Ciclón Primavera",
    "832": "Poder Místico",
    "833": "Erupción de Ira",
    "834": "Acuatacleada",
    "835": "Clorofiláser",
    "836": "Viento Carámbano",
    "837": "Danza Triunfal",
    "838": "Asalto Frontal",
    "839": "Mil Púas Tóxicas",
    "840": "Ala Aural",
    "841": "Rencor Reprimido",
    "842": "Retracción",
    "843": "Triple Flecha",
    "844": "Marcha Espectral",
    "845": "Corte Metralla",
    "846": "Vendaval Gélido",
    "847": "Electormenta",
    "848": "Tifón de Arena",
    "849": "Plegaria Lunar",
    "850": "Bálsamo Osado",
    "851": "Teraexplosión",
    "852": "Telatrampa",
    "853": "Patada Hacha",
    "854": "Homenaje Póstumo",
    "855": "Fotocolisión",
    "856": "Emplatar",
    "857": "Puño Jet",
    "858": "Extracto Picante",
    "859": "Quemarrueda",
    "860": "Proliferación",
    "861": "Pirueta Helada",
    "862": "Asalto Espadón",
    "863": "Plegaria Vital",
    "864": "Salación",
    "865": "Triple Inmersión",
    "866": "Giro Mortífero",
    "867": "Plagio",
    "868": "Fileteo",
    "869": "Genufendiente",
    "870": "Truco Floral",
    "871": "Canto Ígneo",
    "872": "Danza Acuática",
    "873": "Furia Taurina",
    "874": "Fiebre Dorada",
    "875": "Psicohojas",
    "876": "Hidrovapor",
    "877": "Calamidad",
    "878": "Nitrochoque",
    "879": "Electroderrape",
    "880": "Autotomía",
    "881": "Respuesta Fría",
    "882": "Limpieza General",
    "883": "Paisaje Nevado",
    "884": "Brinco",
    "885": "Abrecaminos",
    "886": "Agua Fría",
    "887": "Hipertaladro",
    "888": "Láser Doble",
    "889": "Puño Furia",
    "890": "Cañón Armadura",
    "891": "Espada Lamento",
    "892": "Electropalmas",
    "893": "Martillo Colosal",
    "894": "Resarcimiento",
    "895": "Corte Acuático",
    "896": "Pirochoque",
    "897": "Ominochoque",
    "898": "Ponzochoque",
    "899": "Pugnachoque",
    "900": "Feerichoque",
    "901": "Luna Roja",
    "902": "Cañón Batidor",
    "903": "Bomba Caramelo",
    "904": "Garrote Liana",
    "905": "Electrorrayo",
    "906": "Teraclúster",
    "907": "Láser Caprichoso",
    "908": "Llama Protectora",
    "909": "Relámpago Súbito",
    "910": "Corte Potente",
    "911": "Corte Taquión",
    "912": "Prensa Metálica",
    "913": "Bramido Dragón",
    "914": "Canto Encantador",
    "915": "Furia Ardiente",
    "916": "Golpe Voltaico",
    "917": "Psicorruido",
    "918": "Palma Rauda"
}
export default movesEs;